import { AxiosError } from "axios";
import { useMutation, useQuery } from "react-query";
import { useErrorHandler } from "../../../../../hooks/useErrorHandler";
import {
  addCategory,
  getCategory,
  getCategoryDetail,
  importCategory,
  updateCategory,
} from "./service";
import useSuccessHandler from "../../../../../hooks/useSuccessHandler";
import { useNavigate } from "react-router";

export const useGetCategory = ({
  page,
  keyword,
}: {
  page: number;
  keyword?: string;
}) => {
  const { redirectOnTokenExpired } = useErrorHandler();

  return useQuery({
    queryKey: ["produkKategori", page, keyword],
    queryFn: () => getCategory({ page, keyword }),
    onError: (e: AxiosError) => redirectOnTokenExpired(e),
  });
};

export const useGetCategoryDetail = ({
  product_category_id,
}: {
  product_category_id?: string;
}) => {
  const { redirectOnTokenExpired } = useErrorHandler();

  return useQuery({
    enabled: product_category_id !== undefined,
    queryKey: `produkKategoriDetail`,
    queryFn: () => getCategoryDetail({ product_category_id }),
    onError: (e: AxiosError) => redirectOnTokenExpired(e),
  });
};

export const useAddCategory = (
  { redirect }: { redirect: boolean } = { redirect: true }
) => {
  const { showToastOnError } = useErrorHandler();
  const { showToast } = useSuccessHandler();
  const navigate = useNavigate();

  return useMutation({
    mutationFn: ({ category_name }: { category_name: string }) =>
      addCategory({ category_name }),
    onSuccess: (e) => {
      showToast("Berhasil menambahkan kategori baru");
      if (redirect) {
        navigate("/kategori");
      }
    },
    onError: (e: AxiosError) => showToastOnError(e),
  });
};

export const useUpdateCategory = () => {
  const { showToastOnError } = useErrorHandler();
  const { showToast } = useSuccessHandler();
  const navigate = useNavigate();

  return useMutation({
    mutationFn: ({
      category_name,
      product_category_id,
    }: {
      category_name: string;
      product_category_id: string;
    }) => updateCategory({ category_name, product_category_id }),
    onSuccess: (e) => {
      showToast("Berhasil update kategori");
      navigate("/kategori");
    },
    onError: (e: AxiosError) => showToastOnError(e),
  });
};

export const useImportCategory = () => {
  const { showToastOnError } = useErrorHandler();
  const { showToast } = useSuccessHandler();

  return useMutation({
    mutationKey: ["importProduct"],
    mutationFn: ({ file }: { file: File }) => importCategory({ file }),
    onSuccess: (e) => showToast("Berhasil melakukan import produk"),
    onError: (e: AxiosError) => showToastOnError(e),
  });
};
